import { mutations as MUTATION, actions as ACTION } from './types';
import Api from '@/services/Api';
import { base } from '@/services/Endpoint';
import config from '@/app/editor/config/index';
import getParameterByName from '@/app/utils/getParameterByName';
import { checkKeyValid } from '@/app/utils/checkRoleApply';
import { getEmbedAppUrl } from '@/utils/getEmbedAppUrl';
import { BUILDER_OPEN_NEW_TAB } from '@/constants/feature-flag-key';
import { postMessageToParent } from '@/app/utils/helpers';

type ActionArg = {
  commit: Function;
};
type ShopInfoParam = {
  global_configs?: boolean;
  store_info?: boolean;
};
const actions = {
  [ACTION.GET_SHOP_INFO]({ commit }: ActionArg) {
    return new Promise(async (resolve, reject) => {
      try {
        const params: ShopInfoParam = {
          global_configs: true,
          store_info: true,
        };
        const res = await Api.base.get(base.me, { params });
        if (res.data.status == 'success') {
          commit(MUTATION.COMMIT_SHOP_INFO, res.data.data);
          resolve(res.data.data);
        } else {
          window.location.href = config.domain() + '/login';
          reject('login failed');
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        reject('login failed');
      }
    });
  },

  [ACTION.GET_PAGE_INFO]({ commit }: ActionArg) {
    return new Promise(async (resolve, reject) => {
      try {
        let pageID = getParameterByName('id');
        const pageType = getParameterByName('type');
        const shopifyDomain = getParameterByName('shop') ?? '';
        if (!pageID) {
          pageID = '51460767821';
        }
        const res = await Api.base.get(base.pageInfo(pageID), { params: { type: pageType } });
        if (res.data.status == 'success') {
          commit(MUTATION.COMMIT_PAGE_INFO, res.data.data);
          resolve(res.data.data);
        } else {
          if (checkKeyValid(BUILDER_OPEN_NEW_TAB)) {
            const url = getEmbedAppUrl(shopifyDomain);
            if (window.top) {
              window.top.location.href = url;
            } else {
              window.location.href = url;
            }
            return;
          }
          postMessageToParent({ type: 'windowCloseBuilder' });
          reject('login failed');
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        reject('login failed');
      }
    });
  },
};

export default actions;
